import { FormGroupState, KeyValue } from 'ngrx-forms';

import { ColumnState, IServerSideGetRowsParams } from '@ag-grid-community/core';
import { AgGridFilterModel, GridState } from '@ideapa/app-common';
import { FieldConfig, FilterValue } from '@ideapa/common-interfaces';
import { Action, ActionCreator, createAction, props } from '@ngrx/store';

import { LazyEntityActions } from './models';

export function createActionsFactory<Entity, K extends KeyValue>(
  ENTITY: string
) {
  function getActions(
    manualClose: ActionCreator<
      string,
      (props: {
        path: string;
        navigate?: boolean;
      }) => { path: string; navigate?: boolean } & Action
    >,
    addSuccess: ActionCreator<
      string,
      (props: { item: Entity; notify: boolean; goBack: boolean }) => {
        item: Entity;
        notify: boolean;
        goBack: boolean;
      } & Action
    >,
    updateSuccess: ActionCreator<
      string,
      (props: {
        item: Entity;
        notify: boolean;
        goBack: boolean;
        callback?: (item: Entity) => void;
      }) => {
        item: Entity;
        notify: boolean;
        goBack: boolean;
        callback?: (item: Entity) => void;
      } & Action
    >,
    loadSingleSuccess: ActionCreator<
      string,
      (props: { item: Entity }) => {
        item: Entity;
      } & Action
    >,
    resetState: ActionCreator<
      string,
      (props: { entity: string }) => {
        entity: string;
      } & Action
    >
  ): LazyEntityActions<Entity, K> {
    const formSave = createAction(
      `[CommonLazy/${ENTITY}] Form Save`,
      props<{
        form: FormGroupState<K>;
        callback?: (item: Entity) => void;
      }>()
    );

    const loadGridPage = createAction(
      `[Lazy/${ENTITY}] Load grid page`,
      props<{ params: IServerSideGetRowsParams }>()
    );

    const loadGridPageSuccess = createAction(
      `[Lazy/${ENTITY}] Load grid page success`,
      props<{ rows: Entity[] }>()
    );

    const formDelete = createAction(`[Lazy/${ENTITY}] Form Delete`);

    const displayFormError = createAction(`[Lazy/${ENTITY}] Form Error`);

    const setEntity = createAction(
      `[Lazy/${ENTITY}] Set entity`,
      props<{ entity?: Entity }>()
    );

    const setGridState = createAction(
      `[Lazy/${ENTITY}] Set grid state`,
      props<{ gridState: GridState }>()
    );

    const setPageSize = createAction(
      `[Lazy/${ENTITY}] Set page size`,
      props<{ pageSize: number }>()
    );

    const setCurrentPage = createAction(
      `[Lazy/${ENTITY}] Set current page`,
      props<{ currentPage: number }>()
    );

    const setTotalRows = createAction(
      `[Lazy/${ENTITY}] Set total rows`,
      props<{ totalRows: number }>()
    );

    const setPageLoaded = createAction(
      `[Lazy/${ENTITY}] Set page loaded`,
      props<{ loaded: boolean }>()
    );
    const setColumnState = createAction(
      `[Lazy/${ENTITY}] Set sort model`,
      props<{ columnState?: ColumnState[] }>()
    );

    const setFilterModel = createAction(
      `[CommonLazy/${ENTITY}] Set filter model`,
      props<{ filterModel?: AgGridFilterModel }>()
    );

    const downloadExcel = createAction(
      `[Lazy/${ENTITY}] Download downloadExcel`,
      props<{
        fileName?: string;
        columns?: FieldConfig[];
        join?: string[];
        filters?: FilterValue[];
        orderBy?: { [field: string]: 'asc' | 'desc' };
      }>()
    );

    const downloadPdf = createAction(
      `[Lazy/${ENTITY}] DownloadPdf`,
      props<{
        fileName?: string;
        columns?: FieldConfig[];
        join?: string[];
      }>()
    );

    const selectEntityId = createAction(
      `[Lazy/${ENTITY}] Select Entity Id`,
      props<{
        id: number | undefined;
      }>()
    );

    const showAdvancedFilters = createAction(
      `[Lazy/${ENTITY}] Show Advanced Filters`,
      props<{
        show: boolean;
      }>()
    );

    const addEntity = createAction(`[Lazy/${ENTITY}] Add Entity`);

    const selectItem = createAction(
      `[Lazy/${ENTITY}] Select item`,
      props<{ item: Entity }>()
    );

    return {
      formSave,
      addEntity,
      displayFormError,
      downloadExcel,
      // downloadPdf,
      formDelete,
      loadGridPage,
      loadGridPageSuccess,
      selectEntityId,
      setColumnState,
      setCurrentPage,
      setEntity,
      setFilterModel,
      setGridState,
      setPageLoaded,
      setPageSize,
      setTotalRows,
      showAdvancedFilters,
      manualClose,
      addSuccess,
      updateSuccess,
      resetState,
      loadSingleSuccess,
      selectItem,
    };
  }

  return { getActions };
}
